import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as form from "../form";
import * as listbox from "../listbox";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";

var _msg_notsaved = "";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

/**
* Init (binding button actions)
*/
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ModuleGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationModule/Show?moduleId=" + dataItem.ModuleID + "&breadcrumbLabel=" + dataItem.Name);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ModuleGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationModule/Edit?moduleId=" + dataItem.ModuleID + "&breadcrumbLabel=" + dataItem.Name);
}

export function adaptItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ModuleGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationModule/Adapt?moduleId=" + dataItem.ModuleID + "&breadcrumbLabel=" + dataItem.Name);
}

//--- LR ------------------------------------------------------------//

export function onSaveButtonClicked(Id: number, menuId: number): void {

    const list = JSON.stringify($("#Items_CplSelected").data("kendoListBox").dataItems());
    let url = 'AdministrationModule/SaveFunctionsLR';

    $.ajax({
        type: "POST",
        data:
        {
            Id: Id,
            assigned: list
        },
        url: appsettings.getUrl(url),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != null && responseData != undefined) {
                form.showServerResponse("LRShowResponse", responseData, function () { });

                if (responseData.Succesfully) {
                    disableSaveButton();
                }
            }
        }
    });
}

export function lr_initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Return label changed not saved
*/
export function lr_ldataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

export function enableSaveButton(): void {
    const saveButton = $("#SaveButton");

    if (saveButton.length > 0) {
        saveButton.data("kendoButton").enable(true);
    }
}

export function disableSaveButton(): void {
    const saveButton = $("#SaveButton");

    if (saveButton.length > 0) {
        saveButton.data("kendoButton").enable(false);
    }
}

export function lr_rightClicked(): void {
    enableSaveButton();
    listbox.moveItems("Items_CplNotSelected", "Items_CplSelected", "#LR_Validation", lr_ldataChangedNotSavedYet());
}

export function lr_leftClicked(): void {
    enableSaveButton();
    listbox.moveItems("Items_CplSelected", "Items_CplNotSelected", "#LR_Validation", lr_ldataChangedNotSavedYet());
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this as kendo.ui.Grid;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as ModuleGridVM;
        removeItem(dataItem.ModuleID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function removeItem(moduleId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationModule/Delete"),
        data: {
            moduleId: moduleId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("ModulesGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}

